<template>
<div class="w-full">
  <vs-row>
    <vs-col class="w-full">

      <vx-card >
        <div>
          <!-- 상단 필터 메뉴 - 모바일에서도 잘 보이도록 간격 조정 -->
          <vs-row class="mb-4 flex-wrap">
            <div class="w-full flex flex-wrap items-center">
              <a href="javascript:;" style="color:#6670CB" @click="()=>{handleHeaderMenu(1)}">{{ $t('content.mypage.alert.오늘') }} ({{ unreadCounts.today }})</a>
              <span class="mx-2" style="color:#CDCDCD;">|</span>
              <a href="javascript:;" style="color:#6670CB" @click="()=>{handleHeaderMenu(7)}">{{ $t('content.mypage.alert.최근1주일') }} ({{ unreadCounts.week }})</a>
              <span class="mx-2" style="color:#CDCDCD;">|</span>
              <a href="javascript:;" style="color:#6670CB" @click="()=>{handleHeaderMenu(30)}">{{ $t('content.mypage.alert.최근30일') }} ({{ unreadCounts.month }})</a>
              <span class="flex mt-2 md:mt-0 md:ml-4" style="color:#757575; font-size: 14px;">
                <img src="@/assets/images/icon/icon-warning.svg" alt="login" class="mr-2" style="margin-top:3px;">
                {{ $t('content.mypage.alert.tip') }}
              </span>
            </div>
          </vs-row>

          <!-- 알림 섹션 제목 -->
          <vs-row class="mb-4">
            <vs-col class="flex">
              <h5><i class="dot"></i>{{ $t('content.mypage.alert.알림') }}</h5>
            </vs-col>
          </vs-row>

          <!-- 모바일에서는 탭 메뉴, 데스크탑에서는 그리드 레이아웃 -->
          <div class="mobile-tabs md:hidden mb-4">
            <div class="tab-header flex border-b mb-4">
              <div
                class="tab-item flex-1 text-center py-2 cursor-pointer"
                :class="{'active-tab': activeTab === 'unread'}"
                @click="activeTab = 'unread'"
              >
                미확인 ({{ (unread.total) ? unread.total : '0' }})
              </div>
              <div
                class="tab-item flex-1 text-center py-2 cursor-pointer"
                :class="{'active-tab': activeTab === 'read'}"
                @click="activeTab = 'read'"
              >
                확인 ({{ (read.total) ? read.total : '0' }})
              </div>
            </div>

            <!-- 미확인 알림 (모바일) -->
            <div v-if="activeTab === 'unread'">
              <div class="action-buttons flex flex-wrap justify-end mb-2 gap-2">
                <vs-button v-if="selectUnreadAlertList.length > 0" class="small mb-1" style="font-size: 14px;" color="secondary" type="border" @click="handleClickRemoveSelectUnreadAlert"> 선택 알림 삭제</vs-button>
                <vs-button v-if="selectUnreadAlertList.length > 0" class="small mb-1" style="font-size: 14px;" color="secondary" type="border" @click="handleClickReadNotice"> 선택 알림 확인처리</vs-button>
                <vs-button v-if="unread.list.length > selectUnreadAlertList.length" class="small mb-1" style="font-size: 14px;" color="secondary" @click="handleClickCheckUnreadAll">전체선택</vs-button>
                <vs-button v-if="selectUnreadAlertList.length > 0 && unread.list.length <= selectUnreadAlertList.length" class="small mb-1" style="font-size: 14px;" color="secondary" @click="handleClickUnCheckUnreadAll">전체해제</vs-button>
              </div>

              <div class="mb-3 p-3 alert-item" v-for="(item, index) in unread.list" :key="`unread_${index}_${unread.total}`">
                <div class="flex items-start">
                  <div class="checkbox-container flex-shrink-0 mr-2">
                    <vs-checkbox v-model="item.is_checked" @change="()=>{changeCheckUnread(item)}"></vs-checkbox>
                  </div>
                  <div class="flex-grow" @click="()=>{handleItemClickDetail(item, false)}">
                    <h5 class="mb-2" style="font-size:14px;">{{ item.message }}</h5>
                    <p style="color:#1E0D61; font-width: bold;">{{getBoardName(item.data)}}</p>
                    <p style="font-size:13px;">{{ item.created_at }}</p>
                  </div>
                </div>
              </div>
              <p v-if="unread.list.length === 0" style="text-align: center;">{{ $t('content.mypage.alert.미확인 알림이 없습니다') }}</p>
              <div class="pagination-container mt-4 text-center">
                <k-pagination
                  :total="(unread.lastPage) ? unread.lastPage : 1"
                  v-model="unread.currentPage" @change="handleUnReadChangePage"></k-pagination>
              </div>
            </div>

            <!-- 확인 알림 (모바일) -->
            <div v-if="activeTab === 'read'">
              <div class="action-buttons flex flex-wrap justify-end mb-2 gap-2">
                <vs-button v-if="selectReadAlertList.length > 0" class="small mb-1" style="font-size: 14px;" color="secondary" type="border" @click="handleClickRemoveSelectReadAlert"> 선택 알림 삭제</vs-button>
                <vs-button v-if="read.list.length > selectReadAlertList.length" class="small mb-1" style="font-size: 14px;" color="secondary" @click="handleClickCheckReadAll">전체선택</vs-button>
                <vs-button v-if="selectReadAlertList.length > 0 && read.list.length <= selectReadAlertList.length" class="small mb-1" style="font-size: 14px;" color="secondary" @click="handleCheckUnCheckReadAll">전체해제</vs-button>
              </div>

              <div class="mb-3 p-3 alert-item" v-for="(item, index) in read.list" :key="`read_${index}_${read.total}`">
                <div class="flex items-start">
                  <div class="checkbox-container flex-shrink-0 mr-2">
                    <vs-checkbox v-model="item.is_checked" @change="()=>{changeCheckRead(item)}"></vs-checkbox>
                  </div>
                  <div class="flex-grow opacity-60" @click="()=>{handleItemClickDetail(item, true)}">
                    <h5 class="mb-2" style="font-size:14px;">{{ item.message }}</h5>
                    <p style="color:#1E0D61; font-width: bold;">{{getBoardName(item.data)}}</p>
                    <p style="font-size:13px;">{{ item.created_at }}</p>
                  </div>
                </div>
              </div>
              <p v-if="read.list.length === 0" style="text-align: center;">{{ $t('content.mypage.alert.확인 알림이 없습니다') }}</p>
              <div class="pagination-container mt-4 text-center">
                <k-pagination
                  :total="(read.lastPage) ? read.lastPage : 1"
                  v-model="read.currentPage" @change="handleReadChangePage"></k-pagination>
              </div>
            </div>
          </div>

          <!-- 데스크탑 레이아웃 -->
          <vs-row class="grid hidden md:grid" style="grid-template-columns: 1fr 1px 1fr; align-items: flex-start">
            <vs-col class="pr-3">
              <div class="title mb-2 flex items-center" style="height: 35px;">
                <label>미확인 ({{ (unread.total) ? unread.total : '0' }})</label>
                <div class="flex items-center ml-auto gap-2">
                  <vs-button v-if="selectUnreadAlertList.length > 0" class="small" style="font-size: 14px;" color="secondary" type="border" @click="handleClickRemoveSelectUnreadAlert"> 선택 알림 삭제</vs-button>
                  <vs-button v-if="selectUnreadAlertList.length > 0" class="small" style="font-size: 14px;" color="secondary" type="border" @click="handleClickReadNotice"> 선택 알림 확인처리</vs-button>
                  <vs-button v-if="unread.list.length > selectUnreadAlertList.length" class="small" style="font-size: 14px;" color="secondary" @click="handleClickCheckUnreadAll">전체선택</vs-button>
                  <vs-button v-if="selectUnreadAlertList.length > 0 && unread.list.length <= selectUnreadAlertList.length" class="small" style="font-size: 14px;" color="secondary" @click="handleClickUnCheckUnreadAll">전체해제</vs-button>
                </div>
              </div>
              <div class="mb-4 p-2 pt-3 alert-item" v-for="(item, index) in unread.list" :key="`unread_${index}_${unread.total}`">
                <div class="grid" style="grid-template-columns: 45px 1fr;" >
                  <label class="flex" >
                    <div class="flex" style="margin-right: 10px; padding:0 7px 0 2px; justify-content: center; align-items: center; border-right:1px solid #ededed;">
                      <vs-checkbox v-model="item.is_checked" @change="()=>{changeCheckUnread(item)}"></vs-checkbox>
                    </div>
                  </label>
                  <div class="ml-2" @click="()=>{handleItemClickDetail(item, false)}">
                    <h5 class="mb-2" style="font-size:14px;">{{ item.message }}</h5>
                    <p style="color:#1E0D61; font-width: bold;">{{getBoardName(item.data)}}</p>
                    <p style="font-size:13px;">{{ item.created_at }}</p>
                  </div>
                </div>
              </div>
              <p v-if="unread.list.length === 0" style="text-align: center;">{{ $t('content.mypage.alert.미확인 알림이 없습니다') }}</p>
              <div class="vs-con-table">
                <div class="con-pagination-table vs-table--pagination">
                  <k-pagination
                    :total="(unread.lastPage) ? unread.lastPage : 1"
                    v-model="unread.currentPage" @change="handleUnReadChangePage"></k-pagination>
                </div>
              </div>
            </vs-col>
            <div class="h-full" style="background-color: rgba(205, 205, 205, 0.35)"></div>
            <vs-col class="pl-3">
              <div class="title mb-2 flex items-center" style="height: 35px;">
                <label>확인 ({{ (read.total) ? read.total : '0' }})</label>
                <div class="flex items-center ml-auto gap-2">
                  <vs-button v-if="selectReadAlertList.length > 0" class="small" style="font-size: 14px;" color="secondary" type="border" @click="handleClickRemoveSelectReadAlert"> 선택 알림 삭제</vs-button>
                  <vs-button v-if="read.list.length > selectReadAlertList.length" class="small" style="font-size: 14px;" color="secondary" @click="handleClickCheckReadAll">전체선택</vs-button>
                  <vs-button v-if="selectReadAlertList.length > 0 && read.list.length <= selectReadAlertList.length" class="small" style="font-size: 14px;" color="secondary" @click="handleCheckUnCheckReadAll">전체해제</vs-button>
                </div>
              </div>

              <div class="mb-4 p-2 pt-3 alert-item" v-for="(item, index) in read.list" :key="`read_${index}_${read.total}`">
                <div class="grid" style="grid-template-columns: 45px 1fr;" >
                  <label class="flex" >
                    <div class="flex" style="margin-right: 10px; padding:0 7px 0 2px; justify-content: center; align-items: center; border-right:1px solid #ededed;">
                      <vs-checkbox v-model="item.is_checked" @change="()=>{changeCheckRead(item)}"></vs-checkbox>
                    </div>
                  </label>
                  <div class="ml-2" style="opacity: 0.6;" @click="()=>{handleItemClickDetail(item, true)}">
                    <h5 class="mb-2" style="font-size:14px;">{{ item.message }}</h5>
                    <p style="color:#1E0D61; font-width: bold;">{{getBoardName(item.data)}}</p>
                    <p style="font-size:13px;">{{ item.created_at }}</p>
                  </div>
                </div>
              </div>
              <p v-if="read.list.length === 0" style="text-align: center;">{{ $t('content.mypage.alert.확인 알림이 없습니다') }}</p>
              <div class="vs-con-table">
                <div class="con-pagination-table vs-table--pagination">
                  <k-pagination
                    :total="(read.lastPage) ? read.lastPage : 1"
                    v-model="read.currentPage" @change="handleReadChangePage"></k-pagination>
                </div>
              </div>
            </vs-col>
          </vs-row>

        </div>
      </vx-card>

    </vs-col>
  </vs-row>
</div>
</template>

<script>
import KPagination from '@/components/kPagination/kPagination'
export default {
  name: 'MyPageAlert',
  components: {KPagination},
  data () {
    return {
      activeTab: 'unread', // 모바일에서 기본 탭 설정
      read:{
        list:[],
        total:0,
        lastPage:1,
        currentPage:1,
        perPage:5
      },
      unread:{
        list:[],
        total:0,
        lastPage:1,
        currentPage:1,
        perPage:5
      },
      days_before:30,
      selectUnreadAlertList:[],
      selectReadAlertList:[],

      // 마지막 api 호출시 사용한 옵션
      apiLastLoadOptions: null,

      // 각 탭별 미확인 알림 개수
      unreadCounts: {
        today: 0,
        week: 0,
        month: 0
      },

      // 30일 동안의 전체 알림 데이터 저장
      allAlerts: {
        unread: [],
        read: []
      }
    }
  },

  async created () {
    // 페이지 진입 시 최근 30일 데이터 로드
    await this.loadAllAlertsData();
    // 초기 필터링 (30일)
    this.filterAlertsByDays(30);

    // NotificationDropDown에서 발행하는 이벤트 수신 설정
    this.$root.$on('notifications-updated', this.handleNotificationsUpdated);
  },

  beforeDestroy() {
    // 컴포넌트 제거 시 이벤트 리스너도 제거
    this.$root.$off('notifications-updated', this.handleNotificationsUpdated);
  },

  methods :{
    // NotificationDropDown에서 알림 업데이트 시 호출되는 핸들러
    async handleNotificationsUpdated() {
      // 알림 데이터 다시 로드
      await this.loadAllAlertsData();
    },

    async initAlertList () {
      this.read.currentPage = 1
      this.read.perPage = 10
      this.unread.currentPage = 1
      this.unread.perPage = 10
      await this.loadAllAlertsData();
    },

    // 최근 30일 데이터를 모두 불러오는 함수
    async loadAllAlertsData() {
      const options = {
        page_unread: 1,
        per_page_unread: 100, // 충분히 큰 값으로 설정
        days_before_unread: 30,
        page_read: 1,
        per_page_read: 100, // 충분히 큰 값으로 설정
        days_before_read: 30,
      }

      await this.$store.dispatch('approval/LOAD_NOTIFICATION_LIST', options);

      // 전체 데이터 저장
      const unreadList = this.$store.state.approval.alertUnReadList.map(alert => {
        return { ...alert, is_checked: false, created_date: new Date(alert.created_at) };
      });

      const readList = this.$store.state.approval.alertReadList.map(alert => {
        return { ...alert, is_checked: false, created_date: new Date(alert.created_at) };
      });

      this.allAlerts.unread = unreadList;
      this.allAlerts.read = readList;

      // 탭별 미확인 알림 개수 계산
      this.calculateUnreadCounts();

      // 기본 표시 데이터 설정 (30일)
      this.filterAlertsByDays(30);

      // 우측 상단 알림 수 업데이트
      await this.$store.dispatch("approval/LOAD_NOTIFICATION_UNREAD_LIST", {
        page_unread: 1,
        per_page_unread: 5,
        days_before_unread: 30,
      });
    },

    // 탭별 미확인 알림 개수 계산
    calculateUnreadCounts() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const weekAgo = new Date(today);
      weekAgo.setDate(today.getDate() - 7);
      const monthAgo = new Date(today);
      monthAgo.setDate(today.getDate() - 30);

      this.unreadCounts.today = this.allAlerts.unread.filter(alert => alert.created_date >= today).length;

      this.unreadCounts.week = this.allAlerts.unread.filter(alert => alert.created_date >= weekAgo).length;

      this.unreadCounts.month = this.allAlerts.unread.length;
    },

    // 날짜별 알림 필터링
    filterAlertsByDays(days) {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const filterDate = new Date(today);
      filterDate.setDate(today.getDate() - days);

      // 전체 필터링된 알림을 계산
      const allFilteredUnread = this.allAlerts.unread.filter(alert => alert.created_date >= filterDate);

      const allFilteredRead = this.allAlerts.read.filter(alert => alert.created_date >= filterDate);

      // 전체 개수와 페이지네이션 정보 업데이트
      this.unread.total = allFilteredUnread.length;
      this.unread.lastPage = Math.ceil(allFilteredUnread.length / this.unread.perPage) || 1;

      this.read.total = allFilteredRead.length;
      this.read.lastPage = Math.ceil(allFilteredRead.length / this.read.perPage) || 1;

      // 선택된 항목 초기화
      this.selectUnreadAlertList = [];
      this.selectReadAlertList = [];

      // 현재 페이지 초기화
      this.unread.currentPage = 1;
      this.read.currentPage = 1;

      // 페이지네이션에 맞게 리스트 업데이트
      this.updatePagedLists();
    },

    // 페이지네이션에 맞게 리스트를 업데이트하는 함수
    updatePagedLists() {
      // 미확인 알림 필터링
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const filterDate = new Date(today);
      filterDate.setDate(today.getDate() - this.days_before);

      // 현재 필터 조건에 맞는 전체 미확인 알림
      const allFilteredUnread = this.allAlerts.unread.filter(alert => alert.created_date >= filterDate);

      // 현재 페이지에 표시할 미확인 알림 계산
      const unreadStartIdx = (this.unread.currentPage - 1) * this.unread.perPage;
      const pagedUnread = allFilteredUnread.slice(unreadStartIdx, unreadStartIdx + this.unread.perPage);
      this.unread.list = pagedUnread;

      // 현재 필터 조건에 맞는 전체 확인 알림
      const allFilteredRead = this.allAlerts.read.filter(alert => alert.created_date >= filterDate);

      // 현재 페이지에 표시할 확인 알림 계산
      const readStartIdx = (this.read.currentPage - 1) * this.read.perPage;
      const pagedRead = allFilteredRead.slice(readStartIdx, readStartIdx + this.read.perPage);
      this.read.list = pagedRead;
    },

    handleHeaderMenu(day) {
      this.days_before = day;
      // 필터링 함수 사용
      this.filterAlertsByDays(day);
    },

    handleUnReadChangePage(page) {
      this.unread.currentPage = page;
      this.updatePagedLists();
    },

    handleReadChangePage(page) {
      this.read.currentPage = page;
      this.updatePagedLists();
    },

    getBoardName(data) {
      if (!data) {
        return '';
      }
      const json = JSON.parse(data);

      // board_title이 존재하면 그 값을 사용
      if (json.board_title) {
        return json.board_title;
      }

      // 기존 로직은 fallback으로 유지
      const board_id = json.board_id;
      const board_slug = json.board_slug;

      if (board_id === 53) return '사고조사 보고서'
      if (board_id === 54) return '사고경위서'
      if (board_id === 55) return '목격자 진술서'
      if (board_id === 56) return '실험실 안전사고 보고'
      if (board_id === 57) return '산업재해조사표'
      if (board_id === 58) return '산업안전보건위원회'
      if (board_id === 59) return '안전경영위원회'
      if (board_id === 60) return '안전근로협의체'
      if (board_id === 61) return '안전보건협의체'
      if (board_id === 62) return '아차사고 사례 카드'
      if (board_id === 63) return '아차사고 사례 개선 확인 카드'
      if (board_id === 64) return '실험실 일상 점검표'
      if (board_id === 65) return '실험실 정기 점검표'
      if (board_id === 66) return 'TAC 안전관리 점검표'
      if (board_id === 67) return '밀폐공간 작업프로그램 평가표'
      if (board_id === 68) return '밀폐공간 작업 전 체크리스트'
      if (board_id === 69) return '고압가스 충전실 안전점검표'
      if (board_id === 70) return '한수단 2호 안전점검표'
      if (board_id === 71) return '잠수 운용 계획서'
      if (board_id === 72) return '잠수작업 전 안전점검표'
      if (board_id === 73) return '잠수 운용 결과서'
      if (board_id === 74) return '중량물·운반기계 안전점검표'
      if (board_id === 75) return '작업장 안전점검표'
      if (board_id === 76) return '부적합 및 시정조치 - 안전'
      if (board_id === 77) return '부적합 및 시정조치 - 보건'
      if (board_id === 78) return '작업중지보고서 - 임직원'
      if (board_id === 79) return '작업중지보고서 - 근로자'
      if (board_id === 80) return '작업중지 조치결과서 - 임직원'
      if (board_id === 81) return '작업중지 조치결과서 - 근로자'
      if (board_id === 82) return '정기 위험성 평가'
      if (board_id === 83) return '수시 위험성 평가'
      if (board_id === 84) return '안전작업허가 - 작업수행부서'
      if (board_id === 85) return '안전작업허가 - 수급업체'
      if (board_id === 86) return '안전·보건예산 현황'
      if (board_id === 87) return '작업중지보고서 - 기타'
      if (board_id === 88) return '작업중지 조치결과서 - 기타'

      if (board_slug === 'notice') return '공지사항'
      if (board_slug === 'approval') return '결재 문서함'
      if (board_slug === 'project_monthly_report') return '안전·보건예산 현황'
      if (board_slug === 'project_safety_plan') return '사업장 개요'
      if (board_slug === 'first_risk') return '최초 위험성평가'
      if (board_slug === 'periodical_risk') return '정기 위험성평가'
      if (board_slug === 'risk_evaluation_association') return '정기 위험성평가협의회'
      if (board_slug === 'industry_safety_health_association') return '산업안전보건협의회'
      if (board_slug === 'work_permit') return '작업허가서'
      if (board_slug === 'special_work_permit') return '작업허가서(외부용)'
      if (board_slug === 'daily_safety_check_table') return '일일안전점검표'
      if (board_slug === 'daily_safety_check_diary') return '안전점검일지'
      if (board_slug === 'joint_check_diary') return '합동점검일지'
      if (board_slug === 'plan_management') return '사업장 개요'
      if (board_slug === 'news') return '안전보건관리(총괄)책임자 지시사항'
      if (board_slug === 'qna') return 'Q&A'
      if (board_slug === 'safety_info') return '안전보건 주요 일정'
      if (board_slug === 'field_news') return '구성원 요청사항'
      if (board_slug === 'safety_chief') return '안전보건책임자'
      if (board_slug === 'manpower') return '출역인원'
      if (board_slug === 'industrial_accident') return '산업재해/무재해'
      if (board_slug === 'safety_supplies') return '안전용품 현황'
      if (board_slug === 'construction_equipment') return '건설장비관리'
      if (board_slug === 'state_director') return '환경책임자선임'
      if (board_slug === 'construction_equipment_detail') return '건설장비안전점검결과'
      if (board_slug === 'state_government') return '대관인허가신고'
      if (board_slug === 'environment_check_daily') return '환경일일점검'
      if (board_slug === 'environment_check_monthly') return '환경월간점검'
      if (board_slug === 'environment_support') return '환경지원보고'
      if (board_slug === 'environment_evaluation') return '환경평가'
      if (board_slug === 'environment_report_issue') return '환경이슈보고'
      if (board_slug === 'environment_report_accident') return '환경사고보고'
      if (board_slug === 'state_government_checklist') return '대관신고종류'
      if (board_slug === 'hse_management') return '안전요청' //HSE 교육관리
      if (board_slug === 'safety_request') return '안전요청'
      if (board_slug === 'photo-album') return '사진첩'
      if (board_slug === 'work_news') return '안전보건관리(총괄)책임자 지시사항'
      if (board_slug === 'environment_request') return '환경요청'
      if (board_slug === 'health_request') return '보건요청'

      if (board_slug === 'always_risk') return '수시위험성평가'
      if (board_slug === 'risk_evaluation_association_always') return '수시 위험성평가협의회'
      if (board_slug === 'daily_safety_always_check_table') return '수시 일일안전점검표'
      if (board_slug === 'daily_safety_check_diary_always') return '수시 일일점검일지'
      if (board_slug === 'accident_report') return '사고보고'
      if (board_slug === 'accident_review') return '사고검토'
      if (board_slug === 'safety_check_444') return '444점검'
      if (board_slug === 'equipment_power') return '출역장비'
      if (board_slug === 'partner_agreement') return '파트너사 계약현황'
      if (board_slug === 'safety_check_partner_444') return '4.4.4 점검'
    },

    getProjectName (data) {
      if (!data) {
        return ''
      }
      const json = JSON.parse(data)
      const project_name = (json.project_name) ? json.project_name : '{프로젝트 이름 없음}'
      return `${project_name} | `
    },

    async handleItemClickDetail(data, isRead) {
      const ids = [data.id]
      const json = JSON.parse(data.data)
      const projectId = json.project_id
      const boardId = json.board_id
      const postId = json.post_id

      if (ids > 0) {
        if (!isRead) {
          await this.$store.dispatch('approval/READ_NOTIFICATION', {ids})

          // NotificationDropDown 컴포넌트에서 사용하는 알림 데이터도 강제로 갱신
          this.$store.state.approval.mainAlertUnReadInfo.loaded_at = null;
          await this.$store.dispatch("approval/LOAD_NOTIFICATION_UNREAD_LIST", {
            page_unread: 1,
            per_page_unread: 5,
            days_before_unread: 30,
            isForce: true
          });
        }
        this.movePost(projectId, boardId, postId)
      }
    },

    changeCheckUnread (data) {
      if (this.selectUnreadAlertList.indexOf(data) === -1) {
        this.selectUnreadAlertList.push(data)
      } else {
        this.selectUnreadAlertList.remove(data)
      }
    },

    changeCheckRead (data) {
      if (this.selectReadAlertList.indexOf(data) === -1) {
        this.selectReadAlertList.push(data)
      } else {
        this.selectReadAlertList.remove(data)
      }
    },

    handleClickCheckUnreadAll () {
      const list = this.unread.list;
      if (this.selectUnreadAlertList.length === list.length) {
        this.selectUnreadAlertList = []
      } else {
        this.selectUnreadAlertList = []
        for (const data of list) {
          data.is_checked = true
          this.selectUnreadAlertList.push(data)
        }
      }
    },

    handleClickCheckReadAll () {
      const list = this.read.list;
      if (this.selectReadAlertList.length === list.length) {
        this.selectReadAlertList = []
      } else {
        this.selectReadAlertList = []
        for (const data of list) {
          data.is_checked = true
          this.selectReadAlertList.push(data)
        }
      }
    },


    handleClickUnCheckUnreadAll () {
      if (this.selectUnreadAlertList.length > 0) {
        for (const data of this.selectUnreadAlertList) {
          data.is_checked = false
        }
      }

      this.selectUnreadAlertList = []
    },

    handleCheckUnCheckReadAll () {
      if (this.selectReadAlertList.length > 0) {
        for (const data of this.selectReadAlertList) {
          data.is_checked = false
        }
      }

      this.selectReadAlertList = []
    },

    handleClickRemoveSelectUnreadAlert () {
      this.__removeAlert(this.selectUnreadAlertList)
    },

    handleClickRemoveSelectReadAlert () {
      this.__removeAlert(this.selectReadAlertList)
    },

    async __removeAlert(list) {
      const ids = []
      for (const data of list) {
        ids.push(data.id)
      }
      if (ids.length > 0) {
        await this.$store.dispatch('approval/DELETE_NOTIFICATION', {ids})

        // 오른쪽 상단에 토스트 팝업을 띄움
        this.$vs.notify({
          title: '알림',
          text: '선택한 알림이 삭제 되었습니다.',
          color: 'success',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check'
        })

        // 알림 데이터 다시 로드
        await this.loadAllAlertsData();

        // NotificationDropDown 컴포넌트에서 사용하는 알림 데이터도 강제로 갱신
        this.$store.state.approval.mainAlertUnReadInfo.loaded_at = null;
        await this.$store.dispatch("approval/LOAD_NOTIFICATION_UNREAD_LIST", {
          page_unread: 1,
          per_page_unread: 5,
          days_before_unread: 30,
          isForce: true
        });
      } else {
        alert('삭제할 알림을 선택해주세요.')
      }
    },


    async handleClickReadNotice() {
      const ids = []
      for (const data of this.selectUnreadAlertList) {
        ids.push(data.id)
      }
      if (ids.length > 0) {
        await this.$store.dispatch('approval/READ_NOTIFICATION', {ids})

        // 오른쪽 상단에 토스트 팝업을 띄움
        this.$vs.notify({
          title: '알림',
          text: '선택한 알림이 확인처리 되었습니다.',
          color: 'success',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check'
        })

        // 알림 데이터 다시 로드
        await this.loadAllAlertsData();

        // NotificationDropDown 컴포넌트에서 사용하는 알림 데이터도 강제로 갱신
        this.$store.state.approval.mainAlertUnReadInfo.loaded_at = null;
        await this.$store.dispatch("approval/LOAD_NOTIFICATION_UNREAD_LIST", {
          page_unread: 1,
          per_page_unread: 5,
          days_before_unread: 30,
          isForce: true
        });
      } else {
        alert('확인처리 할 알림을 선택해주세요.')
      }
    },


    movePost (projectId, boardId, postId) {

      /* 안전·보건예산 현황 */
      if (boardId === 3) { this.$router.push({path: `/project/${projectId}/write/report/project_monthly_report/${postId}`}); return }
      /* 최초 위험성평가 */
      if (boardId === 6) { this.$router.push({path: `/project/${projectId}/risk/assessment/first/${postId}`}); return }
      /* 정기위험성평가 */
      if (boardId === 7) { this.$router.push({path: `/project/${projectId}/risk/assessment/regular/${postId}`}); return }
      /* 수시위험성평가 */
      if (boardId === 41) { this.$router.push({path: `/project/${projectId}/risk/assessment/always/${postId}`}); return }
      /* 위험성평가협의회 */
      if (boardId === 8) { this.$router.push({path: `/project/${projectId}/risk/conference/warning/${postId}`}); return }
      /* 수시 위험성평가협의회 */
      if (boardId === 42) { this.$router.push({path: `/project/${projectId}/risk/conference/warning-always/${postId}`}); return }
      /* 산업안전보건위원회 */
      if (boardId === 9) { this.$router.push({path: `/project/${projectId}/risk/conference/safety/${postId}`}); return }
      /* 작업허가서(내부용) */
      if (boardId === 10) { this.$router.push({path: `/project/${projectId}/risk/permit/work/${postId}`}); return }
      /* 작업허가서(외부용) */
      if (boardId === 11) { this.$router.push({path: `/project/${projectId}/risk/permit/work_export/${postId}`}); return }

      /* 안전점검일지 */
      if (boardId === 13) { this.$router.push({path: `/project/${projectId}/risk/check/checklog/${postId}`}); return }
      /* 안전점검일지 */
      if (boardId === 14) { this.$router.push({path: `/project/${projectId}/risk/check/checklogall/${postId}`}); return }
      /* 산업재해무재해 */
      if (boardId === 22) { this.$router.push({path: `/project/${projectId}/safety/accident/report/${postId}`}); return }
      /* 안전용품 현황 */
      if (boardId === 23) { this.$router.push({path: `/project/${projectId}/safety/supplies/${postId}`}); return }
      /* 건설장비관리 */
      if (boardId === 24) { this.$router.push({path: `/project/${projectId}/safety/equipment/plan/${postId}`}); return }
      /* 환경일일점검 */
      if (boardId === 28) { this.$router.push({path: `/project/${projectId}/state/check/daily/${postId}`}); return }
      /* 환경월간점검 */
      if (boardId === 29) { this.$router.push({path: `/project/${projectId}/state/check/monthly/${postId}`}); return }
      /* 환경지원 */
      if (boardId === 30) { this.$router.push({path: `/project/${projectId}/state/support/${postId}`}); return }
      /* 환경평가 */
      if (boardId === 31) { this.$router.push({path: `/project/${projectId}/state/evaluation/${postId}`}); return }
      /* 환경이슈보고 */
      if (boardId === 32) { this.$router.push({path: `/project/${projectId}/state/report/issue/${postId}`}); return }
      /* 환경사고보고 */
      if (boardId === 33) { this.$router.push({path: `/project/${projectId}/state/report/accident/${postId}`}); return }

      /* HSE 교육관리 */
      if (boardId === 35) { this.$router.push({path: `/project/${projectId}/hse/list/safety/${postId}`}); return }
      /* 안전요청 */
      if (boardId === 36) { this.$router.push({path: `/project/${projectId}/prevention/request/safety/${postId}`}); return }
      /* 환경요청 */
      if (boardId === 39) { this.$router.push({path: `/project/${projectId}/prevention/request/environment/${postId}`}); return }
      /* 보건요청 */
      if (boardId === 40) { this.$router.push({path: `/project/${projectId}/prevention/request/health/${postId}`}); return }

      /* 사고보고 */
      if (boardId === 45) { this.$router.push({path: `/project/${projectId}/write/accident/accident_report/${postId}`}); return }
      /* 산재검토 */
      if (boardId === 46) { this.$router.push({path: `/project/${projectId}/write/accident/accident_review/${postId}`}); return }

      /* 444점검 */
      if (boardId === 48) { this.$router.push({path: `/project/${projectId}/write/safety_check/safety_check_444/${postId}`}); return }
      /* 출역장비 */
      if (boardId === 49) { this.$router.push({path: `/project/${projectId}/write/safety_check/safety_check_444/${postId}`}); return }
      /* 파트너사 계약현황 */
      if (boardId === 50) { this.$router.push({path: `/project/${projectId}/plan/partners`}); return }
      /* 444점검 */
      if (boardId === 51) { this.$router.push({path: `/project/${projectId}/write/safety_check_partner/safety_check_partner_444/${postId}`}); return }

      /* 사고조사 보고서 */
      if (boardId === 53) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 사고경위서 */
      if (boardId === 54) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 목격자 진술서 */
      if (boardId === 55) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 실험실 안전사고 보고 */
      if (boardId === 56) { this.$router.push({path: `/project/${projectId}/approval/${boardId}/write/${postId}`}); return }
      /* 산업재해조사표 */
      if (boardId === 57) { this.$router.push({path: `/project/${projectId}/normal/${boardId}/write/${postId}`}); return }
      /* 산업안전보건위원회 */
      if (boardId === 58) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전경영위원회 */
      if (boardId === 59) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전근로협의체 */
      if (boardId === 60) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전보건협의체 */
      if (boardId === 61) { this.$router.push({path: `/project/${projectId}/normal/${boardId}/write/${postId}`}); return }
      /* 아차사고 사례 카드 */
      if (boardId === 62) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 아차사고 사례 개선 확인 카드 */
      if (boardId === 63) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 실험실 일상 점검표 */
      if (boardId === 64) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 실험실 정기 점검표 */
      if (boardId === 65) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* TAC 안전관리 점검표 */
      if (boardId === 66) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 밀폐공간 작업프로그램 평가표 */
      if (boardId === 67) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 밀폐공간 작업 전 체크리스트 */
      if (boardId === 68) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 고압가스 충전실 안전점검표 */
      if (boardId === 69) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 한수단 2호 안전점검표 */
      if (boardId === 70) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 잠수 운용 계획서 */
      if (boardId === 71) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 잠수작업 전 안전점검표 */
      if (boardId === 72) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 잠수 운용 결과서 */
      if (boardId === 73) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 중량물·운반기계 안전점검표 */
      if (boardId === 74) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업장 안전점검표 */
      if (boardId === 75) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 부적합 및 시정조치 - 안전 */
      if (boardId === 76) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 부적합 및 시정조치 - 보건 */
      if (boardId === 77) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지보고서 - 임직원 */
      if (boardId === 78) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지보고서 - 근로자 */
      if (boardId === 79) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지 조치결과서 - 임직원 */
      if (boardId === 80) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지 조치결과서 - 근로자 */
      if (boardId === 81) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 정기 위험성 평가 */
      if (boardId === 82) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 수시 위험성 평가 */
      if (boardId === 83) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전작업허가 - 작업수행부서 */
      if (boardId === 84) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전작업허가 - 수급업체 */
      if (boardId === 85) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전·보건예산 현황 */
      if (boardId === 86) { this.$router.push({path: `/project/${projectId}/approval/${boardId}/write/${postId}`}); return }
      /* 작업중지보고서 - 기타 */
      if (boardId === 87) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지 조치결과서 - 기타 */
      if (boardId === 88) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }

      // BS
      if (boardId >= 100) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`});  }


    },
  }
}
</script>

<style>
.active {
  background-color: #FBFBFF !important;
}
.normal {
  background-color: white !important;
}

/* 모바일 최적화 스타일 */
.mobile-tabs .active-tab {
  color: #6670CB;
  border-bottom: 2px solid #6670CB;
  font-weight: bold;
}

.alert-item {
  border: 1px solid #cdcdcd;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.alert-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .action-buttons {
    flex-wrap: wrap;
  }

  .action-buttons .vs-button {
    margin-bottom: 0.5rem;
  }

  .pagination-container {
    display: flex;
    justify-content: center;
  }
}
</style>
